module.exports = __webpack_public_path__ + "static/selected.b4822448.png";